/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgBoldN = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 2048 2048",
        width: "1em",
        height: "1em",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M1399 128h354v1664h-378L689 746q-22-34-43-68t-41-70h-4q7 67 8 134t1 136v914H256V128h404l660 1013q22 34 43 67t41 69h4q-6-41-7-83t-2-85V128z"
    }));
export default SvgBoldN;
